import { render, staticRenderFns } from "./account2.vue?vue&type=template&id=86a27ac2&scoped=true"
import script from "./account2.vue?vue&type=script&lang=js"
export * from "./account2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a27ac2",
  null
  
)

export default component.exports